<template>
  <div id="error-404">
    <div> 
      <img src="@/assets/image/404-icon.png" alt="">
    </div>
    <div style="margin-left: 40px;">
      <div style="font-size: 280px; color: #FF635D;">404</div>
      <div style="font-size: 28px; margin-top: 50px;">未找到当前页面</div>
      <div style="font-size: 24px; color: #BCC1CD; margin-top: 20px;">或者你无权访问当前页面</div>
      <div style="margin-top: 70px; ">
        <router-link style="font-size: 28px; color: #000;" to="/">回首页 &gt; </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
#error-404 {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
</style>